import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';

function CivilCommercialConstruction() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1599995903128-531fc7fb694b?fm=webp&q=70&auto=format&fit=max&w=1920)' }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Civil & Commercial <span className="text-gold">Construction</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            From large-scale civil works to premier commercial developments, we deliver structures built with precision, strength, and timeless quality
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
              <p>
                Williams Diversified brings decades of expertise to every civil and commercial construction project. Whether it's a state-of-the-art office building, retail complex, or large-scale infrastructure development, we approach each project with meticulous planning and unwavering commitment to quality.
              </p>
              <p>
                Our civil and commercial construction services encompass everything from initial site assessment and design collaboration to final inspections and handover. We work closely with architects, engineers, and stakeholders to ensure projects are completed on time, within budget, and to the highest standards.
              </p>
              <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Our Capabilities</h3>
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-start">
                  <span className="text-gold mr-3">•</span>
                  <span>Ground-up commercial construction</span>
                </li>
                <li className="flex items-start">
                  <span className="text-gold mr-3">•</span>
                  <span>Large-scale infrastructure projects</span>
                </li>
                <li className="flex items-start">
                  <span className="text-gold mr-3">•</span>
                  <span>Mixed-use developments</span>
                </li>
                <li className="flex items-start">
                  <span className="text-gold mr-3">•</span>
                  <span>Office buildings and corporate facilities</span>
                </li>
                <li className="flex items-start">
                  <span className="text-gold mr-3">•</span>
                  <span>Retail and hospitality construction</span>
                </li>
                <li className="flex items-start">
                  <span className="text-gold mr-3">•</span>
                  <span>Site development and preparation</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Ready to Start Your <span className="text-gold">Project?</span>
          </h3>
          <p className="text-gray-300 text-xl mb-10">
            Let's discuss how we can bring your commercial construction vision to life
          </p>
          <Link 
            to="/contact"
            className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
}

export default CivilCommercialConstruction;